module.exports = __webpack_public_path__ + "img/logo-square.71e90270.png";